import { QuantityError, suggestExactAlternatives, toBaseQuantity } from '@wms/shared';

export interface ActiveUnit {
  readonly uomId: string;
  readonly uomCode: string;
  readonly factorToBase: string;
  readonly isBase: boolean;
}

export interface QuantityConversion {
  readonly baseQty: bigint | null;
  readonly error: string | null;
  readonly errorParams: Record<string, string> | undefined;
}

/**
 * 数量换算 + 受控错误（M5-F1 修复的共用实现，出库/转移表单复用，不重新犯
 * 同一个错——之前的 bug 是只传 err.code 当 defaultValue，errors.json 的
 * QUANTITY.NOT_DIVISIBLE 模板需要的 {{inexact}}/{{lower}}/{{upper}}/{{baseUnit}}
 * 插值全部落空。见 inbound-drawer.tsx 顶部同一段说明。
 */
export function resolveQuantityConversion(
  qty: string,
  selectedUnit: ActiveUnit | undefined,
  activeUnits: readonly ActiveUnit[],
): QuantityConversion | null {
  if (!selectedUnit || qty.trim() === '') return null;
  try {
    return {
      baseQty: toBaseQuantity(qty, BigInt(selectedUnit.factorToBase)),
      error: null,
      errorParams: undefined,
    };
  } catch (err) {
    if (err instanceof QuantityError) {
      const params: Record<string, string> = { input: qty, unit: selectedUnit.uomCode };
      if (err.code === 'QUANTITY.NOT_DIVISIBLE') {
        const baseUnit = activeUnits.find((u) => u.isBase);
        const alt = suggestExactAlternatives(qty, BigInt(selectedUnit.factorToBase));
        params.inexact = alt.inexactBase;
        params.lower = alt.lowerBase.toString();
        params.upper = alt.upperBase.toString();
        if (baseUnit) params.baseUnit = baseUnit.uomCode;
      }
      return { baseQty: null, error: err.code, errorParams: params };
    }
    throw err;
  }
}
